/* Seleetech theme */
(function () {
  'use strict';
  var SLT = window.SLT || {};

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + v;
  }
  function sizeImg(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- mobile nav ---------- */
  function toggleNav() { var h = $('header.site-header'); if (h) h.classList.toggle('open'); }

  /* ---------- search overlay ---------- */
  function toggleSearch() {
    var o = $('#searchov'); if (!o) return;
    var on = o.classList.toggle('on');
    if (on) { var i = $('#searchInput'); if (i) setTimeout(function () { i.focus(); }, 60); }
  }

  /* ---------- lightbox ---------- */
  window.SLTopenLb = function (img) { var lb = $('#lightbox'); $('#lbimg').src = img.getAttribute('src'); lb.classList.add('on'); };
  window.SLTcloseLb = function () { $('#lightbox').classList.remove('on'); };

  /* ---------- cart drawer ---------- */
  function openCart() { $('#cartDrawer').classList.add('on'); $('#cartBack').classList.add('on'); }
  function closeCart() { $('#cartDrawer').classList.remove('on'); $('#cartBack').classList.remove('on'); }

  function renderCart(cart) {
    var wrap = $('#cartItems'); if (!wrap) return;
    var badge = $('#cartCount');
    if (badge) { badge.textContent = cart.item_count; badge.style.display = cart.item_count > 0 ? 'grid' : 'none'; }
    if (!cart.items || !cart.items.length) {
      wrap.innerHTML = '<div class="cartempty"><p>Your cart is empty.</p><a class="btn btn-ghost" href="' + (SLT.searchUrl || '/search') + '">Browse builds</a></div>';
      var f = $('#cartFoot'); if (f) f.style.display = 'none';
      return;
    }
    var html = '';
    cart.items.forEach(function (it, i) {
      var img = it.image ? '<img src="' + sizeImg(it.image, 120) + '" alt="">' : '';
      html += '<div class="citem">' +
        '<a class="cthumb" href="' + it.url + '">' + img + '</a>' +
        '<div class="cinfo"><a class="cname" href="' + it.url + '">' + it.product_title + '</a>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="cond">' + it.variant_title + '</div>' : '') +
        '<div class="cq"><button aria-label="Decrease" data-line="' + (i + 1) + '" data-qty="' + (it.quantity - 1) + '">&minus;</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button aria-label="Increase" data-line="' + (i + 1) + '" data-qty="' + (it.quantity + 1) + '">+</button></div></div>' +
        '<div class="cright"><div class="cprice">' + money(it.final_line_price) + '</div>' +
        '<button class="crm" data-line="' + (i + 1) + '" data-qty="0">Remove</button></div></div>';
    });
    wrap.innerHTML = html;
    var sub = $('#cartSubtotal'); if (sub) sub.textContent = money(cart.total_price);
    var f = $('#cartFoot'); if (f) f.style.display = 'block';
    $all('[data-line]', wrap).forEach(function (b) {
      b.addEventListener('click', function () { changeLine(b.getAttribute('data-line'), b.getAttribute('data-qty')); });
    });
  }

  function fetchCart(cb) {
    fetch((SLT.cartUrl || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { renderCart(c); if (cb) cb(c); });
  }
  function changeLine(line, qty) {
    fetch((SLT.changeUrl || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function addToCart(form) {
    var data = new FormData(form);
    var btn = form.querySelector('[type=submit]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    fetch((SLT.addUrl || '/cart/add') + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
      .then(function (r) { return r.json(); })
      .then(function () { fetchCart(function () { openCart(); }); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to cart'; } });
  }

  /* ---------- wire up ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    $all('[data-nav-toggle]').forEach(function (b) { b.addEventListener('click', toggleNav); });
    $all('[data-search-toggle]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); toggleSearch(); }); });
    $all('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
    $all('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });

    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f.matches('form[action*="/cart/add"]')) { e.preventDefault(); addToCart(f); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeCart(); var o = $('#searchov'); if (o) o.classList.remove('on'); SLTcloseLb(); }
    });
    if ($('#cartItems')) fetchCart();
  });

  window.SLTtoggleSearch = toggleSearch;
  window.SLTtoggleChat = function () { var c = $('#chatcard'); if (c) c.classList.toggle('on'); };
})();
